import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'webapp-compat-navigation-empty',
  template: `
    <app-navigation-empty [transparent]="transparent"></app-navigation-empty>
  `,
})
export class CompatNavigationEmptyComponent implements OnInit {
  transparent: boolean;

  ngOnInit() {
    // Note: this is a hack for allowing us to set transparent navigation
    // if the PHP template variable transparent_header is set to true.
    if ((window as any).webappCompat['navigation-empty']) {
      this.transparent = (window as any).webappCompat[
        'navigation-empty'
      ].transparent;
    }
  }
}
